// extracted by mini-css-extract-plugin
export var container = "_9n-0";
export var icon = "_9n-1";
export var text = "_9n-2";